const getters = {
  expertUserName: state => state.report.expertUserName,
  expertUserId: state => state.report.expertUserId,
  expertToken: state => state.report.expertToken,
  getChildData: state => state.report.getChildData,
  checkList: state => state.report.checkList,
  pasturelist: state => state.report.pasturelist,
  pasturedata: state => state.report.pasturedata,
  laboratorydata: state => state.report.laboratorydata,
  laboratorylist: state => state.report.laboratorylist,
  swinedata: state => state.report.swinedata,
  swinelist: state => state.report.swinelist,
  rabiddata: state => state.report.rabiddata,
  rabidlist: state => state.report.rabidlist,
  blueeardata: state => state.report.blueeardata,
  blueearlist: state => state.report.blueearlist,
}
export default getters
